<template>
  <Section v-bind="$attrs">
    <slot name="descSlot" slot="descSlot" />
    <div class="grid" :style="`grid-gap: ${gap}px`">
      <slot v-if="typeof data === 'string' || $slots.text" name="text">
        <div class="text" ref="text">{{ data }}</div>
      </slot>
      <div v-else class="list-grid">
        <dl v-for="({ title, item }, key) in data" :key="key">
          <dt>{{ title }}</dt>
          <dd>{{ item }}</dd>
        </dl>
      </div>
      <div v-if="status" class="status" :class="{ red }">{{ status }}</div>
      <slot v-if="!hideButton" name="button">
        <Button :x-small="!small" :small="small" @click="onClick" :disabled="disabled" :primary="primary">
          {{ button }}
        </Button>
      </slot>
    </div>
    <slot />
  </Section>
</template>

<script>
import Section from '@/components/molecules/Section'
import Button from '@/components/atoms/Button'

/**
 * プロパティセクション
 */
export default {
  name: 'PropertySection',
  components: {
    Section,
    Button,
  },
  props: {
    /** プロパティ名、説明など */
    data: { type: [String, Array] },
    /** ステータスラベル */
    status: { type: String },
    /** ステータス赤 */
    red: Boolean,
    /** ボタン名 */
    button: { type: String, default: '変更' },
    /** primaryボタン */
    primary: { type: Boolean, default: false },
    /** ボタン非活性 */
    disabled: { type: Boolean, default: false },
    /** ボタン非表示 */
    hideButton: { type: Boolean, default: false },
    /** スモールボタン */
    small: { type: Boolean, default: false },
    /** grid-gap */
    gap: { type: Number, default: 16 },
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="postcss" scoped>
.grid {
  align-items: center;
  display: grid;
  font-size: 18px;
  grid-auto-flow: column;
  grid-template-columns: 1fr;
}

.text {
  white-space: pre-wrap;
  word-wrap: break-word;
}

.list-grid {
  display: grid;
  font-size: 18px;
  grid-gap: 8px;

  dl {
    display: grid;
    grid-gap: 24px;
    grid-template-columns: 96px 1fr;
  }
}

.status {
  font-weight: 600;
}

.red {
  color: var(--pure-red);
}
</style>
